import React from 'react'
import { Row } from 'antd'
import { useHover } from 'src/app/hooks'
import { CheckOutlined, PlusOutlined } from '@ant-design/icons'
import styles from './CustomProjectFormPanelHeader.module.scss'
import { CustomCol, CustomTitle, CustomText } from 'src/components'

interface PropsType {
  title: string,
  subtitle: string,
  isActivePanel: boolean,
  isFullCompleted: boolean
}

const CustomProjectFormPanelHeader: React.FC<PropsType> = (props) => {
  const { title, subtitle, isActivePanel, isFullCompleted } = props
  const [hoverRef, isHovered] = useHover<HTMLDivElement>()
  const isActive = isActivePanel || isHovered

  const icon = {
    ACTIVE: { component: CheckOutlined, className: isFullCompleted ? styles.iconCompleted : styles.iconOk },
    NO_ACTIVE: { component: PlusOutlined, className: styles.icon }
  }[isActive ? 'ACTIVE': 'NO_ACTIVE']

  const label = {
    ACTIVE: { color: isFullCompleted ? 'black' : 'blue' },
    NO_ACTIVE: { color: 'black' }
  }[isActive ? 'ACTIVE': 'NO_ACTIVE']

  return (
    <Row className={styles.row} ref={hoverRef}>
      <CustomCol xs={4} lg={1}>
        <icon.component className={icon.className} />
      </CustomCol>
      <CustomCol xs={20} lg={23} className={styles.text}>
        <CustomTitle label={title} type={null} style={{ color: label.color }}/>
        <CustomText label={subtitle} className={styles.subtitle}/>
      </CustomCol>
    </Row>
  )
}

export default CustomProjectFormPanelHeader
